import { useState, useCallback, useEffect } from 'react';
export var useHoverState = function (disabled) {
    if (disabled === void 0) { disabled = false; }
    var _a = useState(false), isHovered = _a[0], setIsHovered = _a[1];
    var _b = useState(false), isActive = _b[0], setIsActive = _b[1];
    var onMouseOver = useCallback(function () {
        setIsHovered(true);
    }, []);
    var onMouseOut = useCallback(function () {
        setIsHovered(false);
    }, []);
    var onMouseDown = useCallback(function () {
        setIsActive(true);
    }, []);
    var onMouseUp = useCallback(function () {
        setIsActive(false);
    }, []);
    useEffect(function () {
        var event = function () {
            if (isActive) {
                onMouseUp();
            }
        };
        document.addEventListener('mouseup', event);
        return function () {
            document.removeEventListener('mouseup', event);
        };
    }, [isActive, onMouseUp]);
    var hoverState = disabled
        ? 'disabled'
        : isActive
            ? 'active'
            : isHovered
                ? 'hover'
                : 'default';
    return { hoverState: hoverState, onMouseOver: onMouseOver, onMouseOut: onMouseOut, onMouseDown: onMouseDown, onMouseUp: onMouseUp };
};
